module.exports = __webpack_public_path__ + "img/screenshot-4.30522aba.png";